const $doc = $(document);
const $win = $(window);

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

// Get from cart.js returns the cart in JSON
if (typeof Shopify.getCart === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if (!cart) {
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr) {
        if (typeof callback === 'function') {
          return callback(cart, textStatus, xhr);
        } else if (typeof Shopify.onCartUpdate === 'function') {
          return Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if (typeof callback === 'function') {
        return callback(cart);
      } else if (typeof Shopify.onCartUpdate === 'function') {
        return Shopify.onCartUpdate(cart);
      }
    }
  };
}

$doc.on('change', '.product .form__row--option select', function() {
  let stringTarget = '';
  let $formThis = $(this).closest('form');
  let $selectThis = $formThis.find('.product-single__variants');
  const $btnSubmit = $formThis.find('button[type="submit"]');

  $formThis.find('.form__row--option option:selected').each(function() {
    const $this = $(this);
    const dataValue = $this.val();
    const dataPos = $this.closest('select').data('option');
    stringTarget += `[data-option-${dataPos}="${dataValue}"]`;
  });

  let selectedVal = $selectThis.find(stringTarget).val();
  $selectThis.val(selectedVal).trigger('change');

  let variantPrice = $selectThis.find('option:selected').data('price-html');
  $('.product__price').html(variantPrice);

  if ($selectThis.find('option:selected').is(':disabled')) {
    $btnSubmit.html($btnSubmit.data('unavailable')).prop('disabled', true);
  } else {
    $btnSubmit.html($btnSubmit.data('available')).prop('disabled', false);
  }
});

$doc.on('submit', '.product .product__form', function(event) {
  event.preventDefault();

  const $form = $(this);

  $form.find('[type="submit"]').text(Shopify.theme.locale.products.product.adding);

  $.ajax({
    url: $form.attr('action'),
    data: $form.serialize()
  })
    .done(function(data) {
      $form.find('[type="submit"]').text(Shopify.theme.locale.products.product.added);

      setTimeout(function() {
        $form.find('[type="submit"]').text(Shopify.theme.locale.products.product.add_to_cart);
      }, 2000);

      // const $html = $(data);
      // $('.cart-drawer').html($html.find('.cart-drawer').html());

      Shopify.getCart(function(cart) {
        $.get('/cart', function(data) {
          var $html = $(data);
          $('.cart-drawer').html($html.find('.cart-drawer').html());
        });

        if (!$('.cart-count').length) {
          // $html.find('.cart-count').appendTo('.cart-trigger');
          $('Cart<span class="cart-count">' + cart.item_count + '</span>').appendTo('.cart-trigger');
        } else {
          // $('.cart-count').html($html.find('.cart-count').html());
          $('.cart-count').html(cart.item_count);
        }
      });
    })
    .fail(function(error) {
      alert(error.responseJSON.description);
    });
});
